module.exports = __webpack_public_path__ + "in.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/in.svg
// module id = 866
// module chunks = 0